import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "Services/Common/errorApiHandleUtils";
import { setupScheduleService } from "Services/Axios/setupScheduleService";
import { getSetupSchedule, getBranchSchedule } from "Services/Features/Branch/Utils/branchUtils";

export const createSetupSchedule = createAsyncThunk(
    'setup/createSetupSchedule',
    async ({branch_id, data}, { dispatch, rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('will_applied_at', data.will_applied_at);
            formData.append('schedule_date', data.schedule_date);
            formData.append('hour_start_at', data.hour_start_at);
            formData.append('hour_end_at', data.hour_end_at);
            formData.append('quota', data.quota);
            const response = await setupScheduleService.createSetupSchedule(branch_id, formData);
            dispatch(getSetupSchedule(branch_id));
            return response.data;
        } catch (error) {
            console.log('API Error:', error);
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const updateSetupSchedule = createAsyncThunk(
    'setup/updateSetupSchedule',
    async ({ branch_id, data }, { dispatch, rejectWithValue }) => {
        try {
            console.log('Update Setup Schedule Data:', data);
            const formData = new FormData();
            formData.append('schedule_id', data.schedule_id);
            formData.append('quota', data.quota);
            const response = await setupScheduleService.updateSetupSchedule(formData);
            dispatch(getBranchSchedule(branch_id));
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deleteSetupSchedule = createAsyncThunk(
    'setup/deleteSetupSchedule',
    async ({ branch_id, id }, { dispatch, rejectWithValue }) => {
        try {
            const response = await setupScheduleService.deleteSetupSchedule(id);
            dispatch(getSetupSchedule(branch_id));
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);
